import { Select } from "@material-ui/core";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Button,
  Box,
  IconButton,
  MenuItem,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { getRoleList } from "../../../redux/API/api_UserManagement";
import "../User-Master/user-management.css";
import { BootstrapInput } from '../../../Utilities/utility.js';

// role list
const roles1 = [
  { RoleId: 1, RoleName: "Admin" },
  { RoleId: 2, RoleName: "Sales Engineer" },
  { RoleId: 3, RoleName: "Designer" },
  { RoleId: 4, RoleName: "Price List" },
];

const UserDalog = React.memo(
  ({ open, onClose, onSave, onUpdate, userToEdit}) => {
    const [error, setError] = useState("");
    const [roles, setRoles] = useState([]);
    const UID = useSelector((state) => state.saveUserIdReducer);
    const userdetails = useSelector(
      (state) => state.storeUserDetailsReducer.userData
    );
    const siteToken = useSelector((state) => state.saveTokenReducer);
    const azureToken = useSelector((state) => state.saveAzureTokenReducer);

    const [formData, setFormData] = useState({
      UserFirstName: "",
      UserLastName: "",
      UserEmail: "",
      RoleName: "",
      Gid: "",
      RoleId: "",
      RoleName: "",
      PassWord: "",
      GeneratedOTP: "",
      SupplierName: "",
      LoggedInUserName: "",
      UserId: "",
    });

    useEffect(() => {
      if (roles.length == 0){
      getRolesData();
      }
      setFormData({
        UserFirstName: userToEdit.editUser?.userFirstName || "",
        UserLastName: userToEdit.editUser?.userLastName || "",
        UserEmail: userToEdit.editUser?.userEmail || "",
        RoleName: userToEdit.editUser?.roleName || "",
        Gid: userToEdit.editUser?.gid || "",
        RoleId: userToEdit.editUser?.roleId || "",
        RoleName: userToEdit.editUser?.roleName || "",
        PassWord: "",
        GeneratedOTP: "",
        SupplierName: "",
        LoggedInUserName: "",
        UserId: userToEdit.editUser?.userId || "",
      });
    }, [userToEdit]);

    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
      setError("");
    };

    const handleRoleChange = (e) => {
      const selectedRole = roles.find((role) => role.RoleId == e.target.value);
      setFormData({
        ...formData,
        RoleId: selectedRole.RoleId,
        RoleName: selectedRole.RoleName,
      });
      setError("");
    };
    const handleSave = () => {
      console.log("form Data", formData);
      const nameRegex = /^[A-Za-z]+$/;
      const emailRegex =
        /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
      const gidRegex = /^[^\s]{8}$/;

      if (
        !formData.UserFirstName ||
        !formData.UserLastName ||
        !formData.UserEmail ||
        !formData.RoleName ||
        !formData.Gid
      ) {
        setError("All fields are required");
        return;
      } else if (!nameRegex.test(formData.UserFirstName)) {
        setError(
          "First Name should contain only letters (no spaces or special character)"
        );
      } else if (!nameRegex.test(formData.UserLastName)) {
        setError(
          "Last Name should contain only letters (no spaces or special character)"
        );
      } else if (!emailRegex.test(formData.UserEmail)) {
        setError("Invalid email format");
      } else if (!gidRegex.test(formData.Gid)) {
        setError("GID must be exactly of 8 characters");
      } else {
        if (userToEdit.editUser) {
          onUpdate(formData);
        } else {
          onSave(formData);
        }
      }
    };

     // getting role list
      function getRolesData() {
      
        getRoleList(
          siteToken,
          azureToken.token,
          UID.id,
          userdetails.userEmail,
          userdetails.gid,
          userdetails.roleName,
          userdetails.roleId
        )
          .then((response) => {
            let ExcelData = [];
            for (let i = 0; i < response.length; i++) {
              let input = {};
              input.RoleId = response[i].roleId;
              input.RoleName = response[i].roleName;
              ExcelData.push(input);
            }
            setRoles(ExcelData);
           
            
          })
          .catch((error) => {
            console.log("Error: " + error, "error");
            
          });
      }

    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "left" }}>
          {userToEdit.editUser ? "Update User" : "Add New User"}
          <IconButton
            onClick={onClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3, mb: 3 }}>
            <TextField
              label="First Name"
              name="UserFirstName"
              value={formData.UserFirstName}
              variant="standard"
              onChange={handleChange}
              fullWidth
              required
              sx={{
                width: "48%",
                "& .MuiFormLabel-asterisk": { color: "red" },
              }}
            />

            <TextField
              label="Last Name"
              name="UserLastName"
              variant="standard"
              value={formData.UserLastName}
              onChange={handleChange}
              fullWidth
              required
              sx={{
                width: "48%",
                "& .MuiFormLabel-asterisk": { color: "red" },
              }}
            />

            <TextField
              label="Email"
              name="UserEmail"
              variant="standard"
              value={formData.UserEmail}
              onChange={handleChange}
              fullWidth
              required
              sx={{
                width: "48%",
                "& .MuiFormLabel-asterisk": { color: "red" },
              }}
            />

            <TextField
              label="GID"
              name="Gid"
              variant="standard"
              value={formData.Gid}
              onChange={handleChange}
              fullWidth
              required
              sx={{
                width: "48%",
                "& .MuiFormLabel-asterisk": { color: "red" },
              }}
            />

            <Box sx={{ minWidth: "48%" }}>
              <Typography sx={{ mb: 1, fontWeight: "bold" }}>Roles</Typography>
              <Select 
                name="roleName"
                value={formData.RoleId || ""}
                onChange={handleRoleChange}
                displayEmpty
                fullWidth
                input={<BootstrapInput />}
                sx={{
                  "& .MuiMenu-paper":{
                    //bgcolor:"rgba(173,216,230,0.8)"
                  }
                }}
              >
                <MenuItem value="" disabled>
                  Select Role
                </MenuItem>
                {roles.map((role) => (
                  <MenuItem key={role.RoleId} value={role.RoleId}>
                    {role.RoleName}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
          {error && (
            <Typography color="error" sx={{ mt: 2, textAlign: "center" }}>
              {error}
            </Typography>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <Button 
            className="btn"
            onClick={handleSave}
            variant="contained"
            color="primary"
            // sx={{
            //   width: "120px",
            //   ml: 2,
            //   fontFamily: "SiemensSans-Bold, sans-serif",
            //   backgroundColor: "#008aa6",
            // }}
          >
            {userToEdit.editUser ? "Update" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

export default UserDalog;
